<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.approvers.add_title')"
  :rightActions="rightActions"
  width="1000"
)
  UiStack(vertical)
    RestTable(
      ref="AssignApproversTable"
      namespace="assign_approvers"
      :headers="headers"
      :itemsPerPageAttachDropdownToBody="false"
      :fetchHandler="getData"
      :initial-filters="initialFilters"
    )
      template(#filters="{ filters, updateFilters }")
        UiStackItem
          UiFormGroup(
            :label="$t('companies.approvers.name')"
            label-for="name-input"
            label-cols="4"
          )
            UiInput#name-input(
              :modelValue="filters.search"
              type="search"
              @update:modelValue="updateFilters({ search: $event })"
              inputSize="30"
            )
      template(#cell:actions="{ item }")
        UiButton(
          v-if="!item.is_assigned"
          size="sm"
          variant="primary"
          icon="Plus"
          @click="assign(item)"
        ) {{ $t("companies.approvers.assign") }}
        UiButton(
          v-if="item.is_assigned"
          size="sm"
          variant="danger"
          icon="Trash"
          @click="deassign(item)"
        ) {{ $t("companies.approvers.deassign") }}
</template>

<script>
import ApiApprovers from "@/api/approvers.js";

export default {
  data() {
    return {
      show: false,
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
        },
        {
          key: "approver_name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "price_limit",
          label: "Price limit",
          sortable: true,
        },
        {
          key: "is_assigned",
          label: "Assigned?",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          variant: "smooth-primary",
          label: this.$t("actions.confirm"),
          onClick: this.close,
        },
      ];
    },
    initialFilters() {
      const filters = {
        target_id: this.target_id,
        target: this.target_name,
      };
      if (this.role == "approver") {
        filters["is_approver"] = true;
      } else if (this.role == "verificator") {
        filters["is_verificator"] = true;
      }
      return filters;
    },
  },

  watch: {
    show(newVal) {
      if (!newVal) {
        this.$emit("closed");
      }
    },
  },

  methods: {
    reload() {
      this.$refs.AssignApproversTable.fetchData();
    },

    open(target_name, target_id, role) {
      this.target_name = target_name;
      this.target_id = target_id;
      this.role = role;
      this.is_approver = false;
      this.is_verificator = false;

      this.show = true;
    },

    close() {
      this.show = false;
    },

    assign(item) {
      ApiApprovers.assignApprover(
        this.$route.params.id,
        item.id,
        this.target_name,
        this.target_id,
        this.role,
      ).then(() => {
        this.reload();
      });
    },

    deassign(item) {
      ApiApprovers.deassignApprover(
        this.$route.params.id,
        item.id,
        this.target_name,
        this.target_id,
        this.role,
      ).then(() => {
        this.reload();
      });
    },

    getData(params, config) {
      return ApiApprovers.fetchApproversList(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.approvers,
          meta: resp.data.meta,
        };
      });
    },
  },
};
</script>
